module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Bookings.dce1c829.PNG";